export function getImage (src: string) {
  return {
    url: `/assets${src}`
  }
}
